import { render } from "./Requirements.vue?vue&type=template&id=1d836f2b"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"
script.render = render

export default script